import React, { FC } from 'react'

export const PhotoCamera: FC<{ width?: string | number; height?: number }> = ({
  width = 124,
  height = 124,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 124 124"
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#41BADE"
        d="M39.263 15.245l-9.916 14.141H1.266v78.445h120.748V29.386H92.53l-9.916-14.141a9.555 9.555 0 0 0-7.823-4.07H47.086a9.555 9.555 0 0 0-7.823 4.07z"
      />
      <path
        fill="#FED576"
        d="M61.64 32.283c18.082 0 32.74 14.625 32.74 32.665S79.722 97.612 61.64 97.612 28.9 82.988 28.9 64.948s14.658-32.665 32.74-32.665"
      />
      <path
        fill="#2E3D49"
        d="M61.64 40.7c13.422 0 24.303 10.856 24.303 24.247 0 13.392-10.88 24.247-24.303 24.247-13.422 0-24.303-10.855-24.303-24.247 0-13.39 10.88-24.246 24.303-24.246"
      />
      <path
        fill="#FFF"
        d="M78.167 61.595H65V48.459H58.28v13.136H45.114V68.3H58.28v13.136H65V68.3h13.167z"
      />
      <path
        fill="#7E878E"
        d="M51.052 46.409c-2.554 1.054-6.341 4.217-7.75 7.029-.61 1.215-.1 2.103.677 2.718 1.098.871 2.66.845 3.748-.037 1.459-1.182 3.665-3.376 4.381-3.912 1.057-.79 2.466-1.581 2.026-4.13-.26-1.507-1.292-1.815-2.091-1.815-.55 0-.991.147-.991.147"
      />
    </g>
  </svg>
)
